import { useTranslate } from '@refinedev/core';
import { Typography, Tag, Table } from 'antd';
import type { ContentMarketingAssetOut } from '@/api/generated/schemas';
import { formatFileSize } from '@/utils/fileSize';

const { Title } = Typography;

export const ProductMarketingAssetsTab = ({
  assets,
}: {
  assets: ContentMarketingAssetOut[];
}) => {
  const t = useTranslate();

  if (assets.length === 0) {
    return (
      <Typography.Text type="secondary">
        {t('content_catalog.products.marketing_assets.not_available')}
      </Typography.Text>
    );
  }

  return (
    <>
      <Title level={4}>
        {t('content_catalog.products.tabs.marketing_assets')}
      </Title>
      <Table<ContentMarketingAssetOut>
        dataSource={assets}
        rowKey="id"
        pagination={false}
        size="small"
        expandable={{
          expandedRowRender: (record) => (
            <pre
              style={{
                fontSize: 12,
                margin: 0,
                whiteSpace: 'pre-wrap',
              }}
            >
              {JSON.stringify(record, null, 2)}
            </pre>
          ),
        }}
      >
        <Table.Column dataIndex="id" title={t('base.fields.id')} />
        <Table.Column
          dataIndex="type"
          title={t('content_catalog.products.marketing_assets.fields.type')}
          render={(value: string) => (
            <Tag>
              {t(`content_catalog.products.marketing_assets.type.${value}`, {
                defaultValue: value,
              })}
            </Tag>
          )}
        />
        <Table.Column
          dataIndex="content_audience"
          title={t(
            'content_catalog.products.marketing_assets.fields.content_audience'
          )}
          render={(value: string) =>
            value ? (
              <Tag>
                {t(
                  `content_catalog.products.marketing_assets.content_audience.${value}`,
                  { defaultValue: value }
                )}
              </Tag>
            ) : (
              '-'
            )
          }
        />
        <Table.Column
          dataIndex="file_format"
          title={t(
            'content_catalog.products.marketing_assets.fields.file_format'
          )}
          render={(value: string) => (value ? <Tag>{value}</Tag> : '-')}
        />
        <Table.Column
          dataIndex="file_size_bytes"
          title={t(
            'content_catalog.products.marketing_assets.fields.file_size'
          )}
          render={(value: number) =>
            value != null ? formatFileSize(value) : '-'
          }
        />
        <Table.Column
          dataIndex="s3_reference"
          title={t(
            'content_catalog.products.marketing_assets.fields.s3_status'
          )}
          render={(value: unknown) => (
            <Tag color={value ? 'green' : 'error'}>
              {value ? t('common.yes') : t('common.no')}
            </Tag>
          )}
        />
      </Table>
    </>
  );
};
